import { z } from "zod";

export const creditVehicleTypes = ["auto_leve", "moto", "caminhao", "onibus"] as const;
export const MAX_PACKAGE_QUANTITY = 999;
// Até 199 garante pelo menos cinco sugestões dentro do limite de 999.
export const packagePolicySchema = z.object({
  allowCustom: z.boolean(),
  stepEnabled: z.boolean(),
  step: z.number().int().min(1).max(199),
}).strict();
export type PackagePolicy = z.infer<typeof packagePolicySchema>;
export const defaultPackagePolicy: PackagePolicy = { allowCustom: true, stepEnabled: true, step: 10 };
export interface PartnerPackageCatalog { policy: PackagePolicy; prices: Partial<Record<string, number>> }

export function quantityAllowed(quantity: number, policy: PackagePolicy): boolean {
  return Number.isSafeInteger(quantity) && quantity > 0 &&
    (!policy.stepEnabled || policy.allowCustom || quantity % policy.step === 0);
}

export function packageQuantities(policy: PackagePolicy, count = 5): number[] {
  if (!policy.stepEnabled) return [];
  const step = policy.step;
  return Array.from({ length: Math.min(Math.max(0, Math.floor(count)), Math.floor(MAX_PACKAGE_QUANTITY / step)) }, (_, i) => (i + 1) * step);
}

export function distributeCredits(total: number, types: string[]): Record<string, number> {
  if (!types.length) return {};
  return Object.fromEntries(types.map((type, i) => [type, Math.floor(total / types.length) + (i < total % types.length ? 1 : 0)]));
}
